import { all } from "redux-saga/effects";
import {
  watchCheckTokenLogin,
  watchLogin,
} from "shared-components/src/components/login/saga/auth.saga";
import watchMe from "shared-components/src/components/users/saga/users.saga";
import { watchGetWeatherCondition } from "shared-components/src/components/weatherForecast/saga/weatherForecast.saga";
import { watchAddActivity, watchGetActivity } from "./sagas/activities.saga";
import watchGetFarm, { watchAddFarm } from "./sagas/farm.saga";
import {
  watchAddFertilizer,
  watchDeleteFertilizer,
} from "./sagas/fertilizers.saga";
import {
  watchAddField,
  watchDeleteField,
  watchGetFields,
  watchUpdateField,
} from "./sagas/fields.saga";
import {
  watchAddIrrigation,
  watchDeleteIrrigation,
} from "./sagas/irrigations.saga";
import {
  watchAddPesticide,
  watchDeletePesticide,
} from "./sagas/pesticides.saga";
import { watchGetSensorsMeasure } from "./sagas/realtime.saga";
import { watchGetSensorMeasureData } from "./sagas/realtimeSensorMeasure.saga";
import {
  watchAddCommandSensor,
  watchAddSensor,
  watchDeleteSensor,
  watchFetchCommandSensor,
  watchUpdateSensor,
} from "./sagas/sensors.saga";
import {
  watchAddSoilPreparation,
  watchDeleteSoilPreparation,
} from "./sagas/soilPreparations.saga";
import { watchSignup } from "./sagas/signup.saga";
import { watchForgotPassword } from "shared-components/src/components/forgotPassword/saga/forgotPassword.saga";
import { watchResetPassword } from "shared-components/src/components/resetPassword/saga/resetPassword.saga";
import { watchGetDatastreamList } from "./sagas/realtimeDatastreamList.saga";
import {
  watchGetCommandData,
  watchSendCommandData,
} from "./sagas/irrigationCommand.saga";
import { watchGetWeatherStations } from "./sagas/weatherStations.saga";
import { watchGetWeatherStationDatastreamList } from "shared-components/src/components/weatherStation/saga/weatherStationDatastreamsList.saga";
import { watchGetWeatherStationDatastreamMeasureData } from "shared-components/src/components/weatherStation/saga/weatherStationTimeRangeMeasure.saga";
import { watchGetModelsData } from "./sagas/realtimeModelsData.saga";
import { watchCreateThing } from "./sagas/thing.saga";
import { watchGetWaterModelData } from "./sagas/waterModelData.saga";
import { watchGetWaterSystems } from "./sagas/waterSystems.saga";

export default function* rootSaga() {
  yield all([
    watchLogin(),
    watchCheckTokenLogin(),
    watchMe(),
    watchGetFarm(),
    watchGetFields(),
    watchAddField(),
    watchUpdateField(),
    watchDeleteField(),
    watchAddSensor(),
    watchDeleteSensor(),
    watchGetActivity(),
    watchAddActivity(),
    watchAddIrrigation(),
    watchDeleteIrrigation(),
    watchAddSoilPreparation(),
    watchDeleteSoilPreparation(),
    watchAddFertilizer(),
    watchDeleteFertilizer(),
    watchAddPesticide(),
    watchDeletePesticide(),
    watchGetSensorsMeasure(),
    watchGetSensorMeasureData(),
    watchAddCommandSensor(),
    watchFetchCommandSensor(),
    watchGetWeatherCondition(),
    watchUpdateSensor(),
    watchSignup(),
    watchAddFarm(),
    watchForgotPassword(),
    watchResetPassword(),
    watchGetDatastreamList(),
    watchSendCommandData(),
    watchGetCommandData(),
    watchGetWeatherStations(),
    watchGetWeatherStationDatastreamList(),
    watchGetWeatherStationDatastreamMeasureData(),
    watchGetModelsData(),
    watchCreateThing(),
    watchGetWaterModelData(),
    watchGetWaterSystems(),
  ]);
}
